<template>
  <div class="modal-out">
    <div class="modal" style="width: 1000px">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" v-loading="loadingForm" style="height: 400px">

        <el-form :model="addForm" :rules="rules" ref="addForm">

          <el-row>

            <el-col :span="8" class="item">
              <el-form-item label="商品标题" required prop="name">
                <el-input v-model="addForm.name" placeholder="输入商品标题"></el-input>
              </el-form-item>
            </el-col>


<!--            <el-col :span="8" class="item">-->
<!--              <el-form-item label="商家" required prop="businessCode">-->
<!--                <el-select v-model="addForm.businessCode" @change="busChange" placeholder="请选择商家" style="width: 100%">-->
<!--                  <el-option-->
<!--                      v-for="item in arr_business"-->
<!--                      :key="item.businessCode"-->
<!--                      :label="item.name"-->
<!--                      :value="item.businessCode">-->
<!--                  </el-option>-->
<!--                </el-select>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
            <el-col :span="8" class="item">
              <el-form-item label="系统分类" required prop="goodsClassCode">
                <el-cascader v-model="addForm.goodsClassCode"
                             :options="govClassList" placeholder="选择系统分类"
                             :props="options" style="width:100%"></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="8" class="item">
              <el-form-item label="商家分类" required prop="goodsClassBusinessCode">
                <el-select v-model="addForm.goodsClassBusinessCode"
                           style="width:100%" placeholder="选择商家分类">
                  <el-option
                      v-for="item in busClassList"
                      :key="item.goodsClassBusinessCode"
                      :label="item.name"
                      :value="item.goodsClassBusinessCode">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>




        </el-form>

      </div>

      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">提交</el-button>
      </div>

    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Add',
  props:['arr_business'],
  data() {
    return {

      loadingForm:false,
      loading: false,

      disPrice: true,
      disImg: true,
      disDetails: true,

      columns:'',
      activeStep:0,
      tablePriceArray:[],
      atrList:[],

      tab:'0',
      imageUrl:"",

      addForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),
        businessCode:'',

        name:'',
        nameMore:'',

        goodsClassCode:'',
        goodsClassBusinessCode:'',

        goodsType:"3",

        priceMin:'0',
        priceStr:'0',
        stock:'100',

        priceList:[],
        selectAtrValue:{},

        isRecommend:'0',
        isBargainPrice:'0',
        isAPP:'0',
        isPad:'0',
        isJiFen:'0',

        head1:'',
        head2:'',
        head3:'',
        head4:'',
        head5:'',

        details:'',

      },


      govClassList:[],
      busClassList:[],


      options:{
        value:'goodsClassCode',
        label:'name',
        children:'goodsClassGovernmentList',
        emitPath:false
      },


      rules:{
        businessCode:[
          { required: true, message: '请选择商家', trigger: 'blur' }
        ],
        name:[
          { required: true, message: '请输入商品标题', trigger: 'blur' }
        ],
        goodsClassCode:[
          { required: true, message: '请选择系统分类', trigger: 'blur' }
        ],
        goodsClassBusinessCode:[
          { required: true, message: '请选择商家分类', trigger: 'blur' }
        ],
        goodsType:[
          { required: true, message: '请选择商品类型', trigger: 'blur' }
        ],
        priceMin:[
          { required: true, message: '请输入商品价格', trigger: 'blur' }
        ],
        stock:[
          { required: true, message: '请输入商品库存', trigger: 'blur' }
        ],
        details:[
          { required: true, message: '请输入商品详情', trigger: 'blur' }
        ],
      },


      goodsTypeValue: [
        {
          value: 3,
          label: '合并服务类'
        }],



      //上传身份证正面相关参数
      limitCount: 5,
      uploadDisabled: false,
      // 是否显示预览图片
      imgVisible: false,
      // 预览图片url
      dialogImageUrl: "",
      fileList: [],

    }
  },
  components:{

  },
  methods: {

    init(){

      this.$refs.addForm.resetFields();

      this.loadingForm = false;

      this.addForm.nameMore = '';

      this.tablePriceArray=[]
      this.atrList=[]
      this.addForm.selectAtrValue={}
      this.addForm.priceList=[]

      for(var key=0;key<=4;key++){
        this.addForm['head'+(key+1)]=''
      }

      this.fileList = [];


      if(this.arr_business.length>0){
        this.addForm.businessCode = this.arr_business[0].businessCode;
        this.busChange(this.addForm.businessCode);

      }

    },
    closeSelf() {
      this.$emit("closeAdd");
    },


    busChange(val){
      this.addForm.businessCode = val;


      let businessType = 0;
      for(let i=0;i<this.arr_business.length;i++){
        if(this.arr_business[i].businessCode == val){
          businessType = this.arr_business[i].businessType;
        }
      }
      if(businessType == 1){
        this.addForm.isAPP = 1;
        this.addForm.isJiFen = 0;
        this.addForm.isPad = 0;
        this.goodsTypeValue= [
          //     {
          //   value: 2,
          //   label: '单独服务类'
          // },
          {
            value: 3,
            label: '合并服务类'
          }];
      }
      if(businessType == 2){
        this.addForm.isAPP = 0;
        this.addForm.isJiFen = 1;
        this.addForm.isPad = 0;
        this.goodsTypeValue= [
          //     {
          //   value: 2,
          //   label: '单独服务类'
          // },
          {
            value: 3,
            label: '合并服务类'
          }];
      }
      if(businessType == 3){
        this.addForm.isAPP = 1;
        this.addForm.isJiFen = 0;
        this.addForm.isPad = 1;
        this.goodsTypeValue= [{
          value: 3,
          label: '合并服务类'
        }];
      }
      if(businessType == 4){
        this.addForm.isAPP = 1;
        this.addForm.isJiFen = 0;
        this.addForm.isPad = 0;
        this.goodsTypeValue= [{
          value: 3,
          label: '合并服务类'
        }];
      }


      this.govClassList = [];
      this.addForm.goodsClassCode = '';
      this.getClassGov();

      this.busClassList = [];
      this.addForm.goodsClassBusinessCode = '';
      this.getClassBus();

    },

    getClassGov:function (){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"GoodsClassGovernment/List",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then((response) => {
        if (response.data.error === 0) {
          this.govClassList = response.data.data;
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }
      })
    },

    getClassBus:function (){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"GoodsClassBusiness/GovPage",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          businessCode:this.addForm.businessCode,
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.busClassList = response.data.data;
            }else if(response.data.error === 1){
              this.$message.error(response.data.message)
            }
          }
      )
    },


    handelIncrease(step) {
      this.addForm.details=step
    },






    confirm(addForm){

      this.$refs[addForm].validate((valid) => {
        if(valid){

          if(this.fileList.length==0){
            //this.$message.warning('请至少上传一张图片')
            //return
          }

          this.addSubmit();

        }else {
          console.log('error submit!!');
          return false;
        }
      })


    },

    addSubmit(){

      for(let i=0;i<this.fileList.length;i++){
        let path = this.fileList[i].url;
        path = path.replace(this.$imgUrl,'');

        this.addForm['head'+(i+1)] = path;
      }

      this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);


      if(this.atrList.length==0){
        this.addForm.priceList=[{goodsColorCode:'',goodsSizeCode:'',stock:this.addForm.stock,price:this.addForm.priceMin}]
        this.addForm.priceStr=this.addForm.priceMin;
      }

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Goods/GovAddBus",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })
    },





    // 预览图片
    handlePictureCardPreview(file) {
      this.imgVisible = true;
      this.dialogImageUrl = file.url;
    },
    // 删除图片
    handleRemove(file, fileList) {
      this.uploadDisabled = fileList.length >= this.limitCount;

      let Pics = this.fileList;
      Pics.forEach((item, index) => {
        if (file.url == item.url) {
          Pics.splice(index, 1);
        }
      })
      Pics.forEach((item, index) => {
        if (file.uid == item.uid) {
          Pics.splice(index, 1);
        }
      })

    },

    //图片更改
    handleChange(file,fileList) {
      this.fileList.push({uid:file.uid,name:file.name,url:''});
      this.uploadDisabled = fileList.length >= this.limitCount;
    },

    uploadHttp(file) {

      let fd = new FormData();
      fd.append('file',file.file);
      fd.append('staffCode',getStaffCode());
      fd.append('timeStr',timeStr);
      fd.append('sign',hex_md5("timeStr=" + timeStr + "&key="+this.$signKey));

      let that = this;
      this.$axios.post(this.$shopUrl+'Upload/Imgs',fd).then(function(res){
        //console.log(res.data);

        if(res.data.error == 0){
          for(let i=0;i<that.fileList.length;i++){
            if(that.fileList[i].uid == file.file.uid){
              that.fileList[i].url = that.$imgUrl+ res.data.data.path;
            }
          }
        }
        else if(res.data.error == 1){
          let Pics = that.fileList;
          Pics.forEach((item, index) => {
            if (file.file.uid == item.uid) {
              Pics.splice(index, 1);
            }
          })
        }

        that.uploadDisabled = that.fileList.length >= that.limitCount;


      }).catch(error => {
        console.log(error);

        let Pics = that.fileList;
        Pics.forEach((item, index) => {
          if (file.file.uid == item.uid) {
            Pics.splice(index, 1);
          }
        })

        that.uploadDisabled = that.fileList.length >= that.limitCount;

      })


    },






  }
}


</script>


<style>
.disabled .el-upload--picture-card {
  display: none;
}
</style>

<style lang="scss" scoped>

</style>
